console.log("script carrousel.js 7x");

/*
  Compteur global : garantit des labels uniques même si
  genererCarrousel() est appelé plusieurs fois (lazy load, etc.)
*/
let carouselGlobalCount = 0;

/* ─────────────────────────────────────────────
   1. GÉNÉRATION DE LA STRUCTURE DOM
   – enveloppe chaque section dans .carousel puis
     .carousel-container-v4 et injecte les contrôles.
   – ne touche pas au contenu HTML des articles.
───────────────────────────────────────────── */
function genererCarrousel() {
  const sections = document.querySelectorAll('.o-list-style-5005');
  if (!sections.length) return;

  const textePrecedent = __('textePrecedent');
  const texteSuivant = __('texteSuivant');
  const texteStop = __('texteStop');

  sections.forEach(section => {
    carouselGlobalCount++;

    /*
      Label du landmark : "Diaporama N"
      – numéro toujours présent car plusieurs carousels
        peuvent coexister sur la même page
    */
    const label = `Diaporama ${carouselGlobalCount}`;

    /* ── div.carousel : fenêtre d'affichage (overflow:hidden) ── */
    const carouselDiv = document.createElement('div');
    carouselDiv.className = 'carousel';
    /*
      aria-live ici (pas sur la section) : seul le contenu
      de la slide visible sera annoncé au changement.
      aria-atomic="false" : lecture partielle, pas de tout relire.
    */
    carouselDiv.setAttribute('aria-live', 'polite');
    carouselDiv.setAttribute('aria-atomic', 'false');

    /*
      ── div.carousel__slider : bande défilante ──
      C'est ce div (neutre, sans sémantique) qui reçoit le translateX,
      et non la <section> — ce qui évitait le bug de largeur sur petits écrans
      causé par display:flex sur un élément sémantique bloc.
    */
    const sliderDiv = document.createElement('div');
    sliderDiv.className = 'carousel__slider';

    section.parentNode.insertBefore(carouselDiv, section);
    carouselDiv.appendChild(sliderDiv);   // slider dans carousel
    const articles = Array.from(section.querySelectorAll('article'));
    articles.forEach(article => sliderDiv.appendChild(article));


    /* ── div.controls ── */
    const controlsDiv = document.createElement('div');
    controlsDiv.className = 'controls';
    /*
      role="group" + aria-label : regroupe les boutons
      en un seul landmark identifiable au clavier.
    */
    controlsDiv.setAttribute('role', 'group');
    controlsDiv.setAttribute('aria-label', 'Contrôles du carrousel');

    /*
      Boutons :
      – aria-label directement sur le <button> (pas sur le span icône)
      – aria-hidden="true" sur les icônes décoratives
      – aria-pressed sur toggle pour exposer l'état play/pause
    */
    controlsDiv.innerHTML = `
      <button class="prev" aria-label="${textePrecedent}">
        <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-fleche_rond_gauche" aria-hidden="true">
          <use href="/static/icons/uga.svg#icon-fleche_rond_gauche"></use>
        </svg>
      </button>
      <button class="toggle" aria-label="${texteStop}" aria-pressed="true">
        <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-pause_rond" aria-hidden="true">
          <use href="/static/icons/uga.svg#icon-pause_rond"></use>
        </svg>
      </button>
      <button class="next" aria-label="${texteSuivant}">
        <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-fleche_rond_droit" aria-hidden="true">
          <use href="/static/icons/uga.svg#icon-fleche_rond_droit"></use>
        </svg>
      </button>
      <div class="counter" aria-live="polite" aria-atomic="true"></div>
    `;

    /* ── div.carousel-container-v4 : landmark région principal ── */
    const containerDiv = document.createElement('div');
    containerDiv.className = 'carousel-container-v4';
    /*
      role="region" + aria-roledescription="carrousel" :
      pattern recommandé W3C ARIA APG.
      Sans aria-label, role="region" est ignoré comme landmark
      par les lecteurs d'écran → on pose toujours le label.
    */
    containerDiv.setAttribute('role', 'region');
    containerDiv.setAttribute('aria-roledescription', 'carrousel');
    containerDiv.setAttribute('aria-label', label);

    carouselDiv.parentNode.insertBefore(containerDiv, carouselDiv);
    containerDiv.appendChild(carouselDiv);
    containerDiv.appendChild(controlsDiv);

    /* Affichage : le carousel est prêt */
    containerDiv.classList.add('affiche');
  });
}


/* ─────────────────────────────────────────────
   2. ANIMATION ET INTERACTIONS
   – gère la navigation (prev/next/toggle/clavier/swipe)
   – met à jour aria-hidden et tabindex à chaque changement
   – respecte prefers-reduced-motion
───────────────────────────────────────────── */
function animerCarrousel() {
  const carousels = document.querySelectorAll('.carousel-container-v4');
  if (!carousels.length) return;

  const texteLancer = __('texteLancer');
  const texteStop = __('texteStop');

  /* Respect du réglage système "réduire les animations" */
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  carousels.forEach(container => {
    /*
      slider déclaré ici, dans le forEach,
      après que container est défini.
    */
    const slider = container.querySelector('.carousel__slider');
    const items = Array.from(container.querySelectorAll('article'));
    const total = items.length;
    const counter = container.querySelector('.counter');
    const toggleBtn = container.querySelector('.toggle');
    const nextBtn = container.querySelector('.next');
    const prevBtn = container.querySelector('.prev');
    const carousel = container.querySelector('.carousel');
    const controls = container.querySelector('.controls');

    let index = 0;
    /* Autoplay off si l'utilisateur préfère moins de mouvement */
    let playing = !reduceMotion;
    let interval = playing ? setInterval(nextSlide, 5000) : null;

    /* ── Mise à jour visuelle + ARIA ── */
    function updateCarousel(instant = false) {

      if (instant) {
        slider.style.transition = 'none';
      } else {
        slider.style.transition = 'transform 0.6s ease';
      }
      slider.style.transform = `translateX(-${index * 100}%)`;
      /*
        translateX sur le slider (div neutre),
        pas sur la section — évite le bug de largeur petits écrans.
      */
      //slider.style.transform = `translateX(-${index * 100}%)`;

      /* Compteur lu par les lecteurs d'écran (aria-live) */
      counter.textContent = `${index + 1} / ${total}`;

      /*
        Pour chaque article :
        – aria-hidden="true" sur les slides cachées
        – tabindex="-1" sur tous les éléments interactifs des slides cachées
          → ils disparaissent de l'ordre de tabulation
      */
      items.forEach((article, i) => {
        const visible = i === index;
        article.setAttribute('aria-hidden', String(!visible));
        article.querySelectorAll('a, button, [tabindex]').forEach(el => {
          if (visible) {
            el.removeAttribute('tabindex');
          } else {
            el.setAttribute('tabindex', '-1');
          }
        });
      });

      repositionnerControls();
    }

    // function nextSlide() {
    //   index = (index + 1) % total;
    //   updateCarousel();
    // }

    function nextSlide() {
      if (index === total - 1) {
        // On était à la dernière : retour instantané à 0
        index = 0;
        updateCarousel(true);
        // Réactive la transition après le saut
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            slider.style.transition = 'transform 0.6s ease';
          });
        });
      } else {
        index++;
        updateCarousel();
      }
    }

    function prevSlide() {
      /* Boucle vers la dernière slide (pas de blocage à 0) */
      index = (index - 1 + total) % total;
      updateCarousel();
    }

    /* ── Gestion centralisée de l'état play / pause ── */
    function setPlaying(shouldPlay) {
      playing = shouldPlay;
      if (playing) {
        interval = setInterval(nextSlide, 5000);
        toggleBtn.setAttribute('aria-label', texteStop);
        toggleBtn.setAttribute('aria-pressed', 'true');
        toggleBtn.querySelector('svg').setAttribute('class', 'icon icon-pause_rond');
        toggleBtn.querySelector('use').setAttribute('href', '/static/icons/uga.svg#icon-pause_rond');
      } else {
        clearInterval(interval);
        toggleBtn.setAttribute('aria-label', texteLancer);
        toggleBtn.setAttribute('aria-pressed', 'false');
        toggleBtn.querySelector('svg').setAttribute('class', 'icon icon-play2');
        toggleBtn.querySelector('use').setAttribute('href', '/static/icons/uga.svg#icon-play2');
      }
    }

    /* ── Boutons prev / next ── */
    nextBtn.addEventListener('click', () => {
      nextSlide();
      if (playing) setPlaying(false);
    });

    prevBtn.addEventListener('click', () => {
      prevSlide();
      if (playing) setPlaying(false);
    });

    /* ── Bouton toggle play/pause ── */
    toggleBtn.addEventListener('click', () => setPlaying(!playing));

    /* ── Pause au survol souris ── */
    carousel.addEventListener('mouseenter', () => {
      if (playing) setPlaying(false);
    });
    carousel.addEventListener('mouseleave', () => {
      if (!playing) setPlaying(true);
    });

    /*
      ── Navigation clavier ← →
      Écouté sur le container (pas sur document) :
      les touches ne déclenchent ce carousel que si
      le focus est à l'intérieur.
    */
    container.addEventListener('keydown', e => {
      if (e.key === 'ArrowRight') {
        nextSlide();
        if (playing) setPlaying(false);
      }
      if (e.key === 'ArrowLeft') {
        prevSlide();
        if (playing) setPlaying(false);
      }
    });

    /* ── Swipe mobile ── */
    let startX = 0;
    carousel.addEventListener('touchstart', e => {
      startX = e.touches[0].clientX;
    });
    carousel.addEventListener('touchend', e => {
      const diff = e.changedTouches[0].clientX - startX;
      if (Math.abs(diff) > 30) {
        diff < 0 ? nextSlide() : prevSlide();
        if (playing) setPlaying(false);
      }
    });

    // const contentEl = document.querySelector('[id="content"]');

    const main = container.closest('main');
    const isFicheAccueil = main && main.classList.contains('main--ficheaccueil');

    const referenceEl = isFicheAccueil
      ? container.closest('.card')
      : document.getElementById('content');

    /* ── Minicarrousel (largeur < 808px) ── */
    function updateMiniClass() {

      const referenceWidth = referenceEl
        ? referenceEl.getBoundingClientRect().width
        : null;

      const isMini = container.offsetWidth < 808;
      container.classList.toggle('minicarrousel', isMini);

      /* Applique la largeur de la référence au container uniquement en minicarrousel,
         pour contourner le stretch des grilles parentes.
         Sur les pages d'accueil (référence = .card), pas de padding à retirer. */
      const offset = isFicheAccueil ? 0 : 72;

      if (isMini && referenceWidth) {
        container.style.width = (referenceWidth - offset) + 'px';
      } else {
        container.style.width = '';
      }

      repositionnerControls();
    }

    function repositionnerControls() {

      // En minicarrousel, on laisse le CSS gérer la position
      if (container.classList.contains('minicarrousel')) {
        controls.style.position = '';
        controls.style.top = '';
        return;
      }

      const activeItem = items[index];
      const img = activeItem.querySelector('img');
      if (!img) return;

      const applyPosition = () => {
        // Revérification nécessaire : le chargement de l'image (event 'load')
        // peut survenir APRÈS que le container soit passé en minicarrousel
        // (ex: updateMiniClass() a tourné entre-temps). Sans ce check,
        // on applique un top calculé alors qu'on est déjà en mini.
        if (container.classList.contains('minicarrousel')) {
          controls.style.position = '';
          controls.style.top = '';
          return;
        }

        const rect = img.getBoundingClientRect();
        const containerRect = container.getBoundingClientRect();

        controls.style.position = 'absolute';
        controls.style.top = `${rect.top - containerRect.top + img.height - 100}px`;
      };

      if (img.complete && img.naturalHeight !== 0) {
        applyPosition();
      } else {
        img.addEventListener('load', applyPosition, { once: true });
      }
    }

    /* ── Adaptation si le réglage système change en cours de session ── */
    window.matchMedia('(prefers-reduced-motion: reduce)')
      .addEventListener('change', e => {
        if (e.matches && playing) setPlaying(false);
      });

    /* Init */
    updateMiniClass();   // pose .minicarrousel avant tout calcul
    updateCarousel();
    window.addEventListener('resize', updateMiniClass);
  });
}

/* ── Exécution ── */
genererCarrousel();
animerCarrousel();